<template>
  <div class="mom-subapp-pool">
    <mom-subapp
      v-for="frame in frames"
      v-show="$route.fullPath === frame.fullPath"
      :key="`${frame.fullPath}:${frame.instanceKey}`"
      :route-meta="frame.routeMeta"
      :route-query="frame.routeQuery"
    />
  </div>
</template>

<script>
import {
  closeMomIframeTabs,
  openMomIframeTab,
  refreshMomIframeTab
} from '@/utils/mom-iframe-tabs'
import MomSubapp from './MomSubapp'

export default {
  name: 'MomSubappPool',
  components: {
    MomSubapp
  },
  data () {
    return {
      frames: []
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        this.openRoute(route)
      }
    }
  },
  methods: {
    openRoute (route) {
      this.frames = openMomIframeTab(this.frames, route)
    },
    refresh (fullPath) {
      this.frames = refreshMomIframeTab(this.frames, fullPath)
    },
    close (fullPaths) {
      this.frames = closeMomIframeTabs(this.frames, fullPaths)
    }
  }
}
</script>

<style lang="less" scoped>
.mom-subapp-pool {
  width: 100%;
  height: 100%;
}
</style>
